import {clearProductForm, sendApplicant, showProductModalForm} from "@js/modules/public/services/plans";

$(() => {
    if ($('body').width() < 1200) {
        const textForList = [
            'университет получит информацию, отражающую положение вуза среди образовательных организаций, которые реализуют ' +
            'подобные профильные программы',
            'сопоставление с выбранными вузами позволит выявить потенциально сильные стороны и определить точки роста, ' +
            'которые могут повлиять на позиционирование в Национальном агрегированном рейтинге'
        ];
        $('.second-block__list .list__item').each((index, item) => {
            $(item).text(textForList[index]);
        });
    }

    showProductModalForm();
    clearProductForm();
    sendApplicant();
});
